import React, { useState, useEffect } from 'react';

import './Timer.scss';
import { Box } from '@mui/material';

/**Stylized div
 * @param {object} props Incoming JSX attributes.
 * @param {function} props.timerCallback A callback to a getRemainingTime method from the useIdleTimer Hook.
 * @returns {JSX.Element} Stylized div
 * @see {@link https://bitbucket.org/pcgeducation/shipyard/src/master/shipyard-web/src/components/shared/Timer.md Timer Documentation} for further information
 */

function Timer({ timerCallback, ...restOfProps}) {
    const convertToMinutes = (ms) => {
        return Math.floor(ms/1000/60);
    }
    const convertToSeconds = (ms) => {
        return Math.floor((ms/1000) % 60);
    }

    const [minutes, setMinutes] = useState(convertToMinutes(timerCallback?.()));

    const [seconds, setSeconds] = useState(convertToSeconds(timerCallback?.()));

    useEffect(() => {
        let myInterval = setInterval(() => {
            setMinutes(convertToMinutes(timerCallback?.()));
            setSeconds(convertToSeconds(timerCallback?.()));
        }, 1000);
        return () => {
            clearInterval(myInterval);
        };
    });

    return (
        <Box {...restOfProps}>
            {minutes === 0 && seconds === 0 ? null : (
                <h1 className="timer">
                    {minutes} min {seconds < 10 ? '0' + seconds : seconds} secs
                </h1>
            )}
        </Box>
    );
}

export default Timer;
